import { render, staticRenderFns } from "./Illu4x.vue?vue&type=template&id=1dd7c35a&"
import script from "./Illu4x.vue?vue&type=script&lang=js&"
export * from "./Illu4x.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports